"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.testnet = exports.mainnet = void 0;
exports.mainnet = {
    bLunaAddress: "terra1kc87mu460fwkqte29rquh4hc20m54fxwtsx7gp",
    bLunaHubAddress: "terra1mtwph2juhj0rvjz7dy92gvl6xvukaxu8rfv8ts",
    bLunaRwardAddress: "terra17yap3mhph35pcwvhza38c2lkj7gzywzy05h7l0",
    aUSTAddress: "terra1hzh9vpxhsk8253se0vv5jj6etdvxu3nv8z07zu",
    ANCAddress: "terra14z56l0fp2lsf86zy3hty2z47ezkhnthtr9yq76",
    ANCPairAddress: "terra1gm5p3ner9x9xpwugn9sp6gvhd0lwrtkyrecdn3",
    marketAddress: "terra1sepfj7s0aeg5967uxnfk4thzlerrsktkpelm5s",
    bLunaCustodyAddress: "terra1ptjp2vfjrwh0j0faj9r6katm640kgjxnwwq9kn",
    LPStakingAddress: "terra1897an2xux840p9lrh6py3ryankc6mspw49xse3",
    AncUstLPAddress: "terra1gecs98vcuktyfkrve9czrpgtg0m3aq586x6gzm",
    govAddress: "terra1f32xyep306hhcxxxf7mlyh0ucggc00rm2s9da5",
    airdropAddress: "terra146ahqn6d3qgdvmj8cj96hh03dzmeedhsf0kxqm",
    bETHAddress: "terra1dzhzukyezv0etz22ud940z7adyv7xgcjkahuun",
    bETHRwardAddress: "terra1939tzfn4hn960ychpcsjshu8jds3zdwlp8jed9",
    bETHCustodyAddress: "terra10cxuzggyvvv44magvrh3thpdnk9cmlgk93gmx2",
    liquidationAddress: "terra1e25zllgag7j9xsun3me4stnye2pcg66234je3u",
};
exports.testnet = {
    bLunaAddress: "terra1u0t35drzyy0mujj8rkdyzhe264uls4ug3wdp3x",
    bLunaHubAddress: "terra1fflas6wv4snv8lsda9knvq2w0cyt493r8puh2e",
    bLunaRwardAddress: "terra1ac24j6pdxh53czqyrkr6ygphdeftg7u3958tl2",
    aUSTAddress: "terra1ajt556dpzvjwl0kl5tzku3fc3p3knkg9mkv8jl",
    ANCAddress: "terra1747mad58h0w4y589y3sk84r5efqdev9q4r02pc",
    ANCPairAddress: "terra1wfvczps2865j0awnurk9m04u7wdmd6qv3fdnvz",
    marketAddress: "terra15dwd5mj8v59wpj0wvt233mf5efdff808c5tkal",
    bLunaCustodyAddress: "terra1ltnkx0mv7lf2rca9f8w740ashu93ujughy4s7p",
    LPStakingAddress: "terra19nxz35c8f7t3ghdxrxherym20tux8eccar0c3k",
    AncUstLPAddress: "terra1vg0qyq92ky9z9dp0j9fv5rmr2s80sg605dah6f",
    govAddress: "terra16ckeuu7c6ggu52a8se005mg5c0kd2kmuun63cu",
    airdropAddress: "terra1u5ywhlve3wugzqslqvm8ks2j0nsvrqjx0mgxpk",
    bETHAddress: "terra19mkj9nec6e3y5754tlnuz4vem7lzh4n0lc2s3l",
    bETHRwardAddress: "terra1ja3snkedk4t0zp7z3ljd064hcln8dsv5x004na",
    bETHCustodyAddress: "terra1j6fey5tl70k9fvrv7mea7ahfr8u2yv7l23w5e6",
    liquidationAddress: "terra18j0wd0f62afcugw2rx5y8e6j5qjxd7d6qsc87r",
};
//# sourceMappingURL=addresses.js.map